import React from 'react'
import Text from '../../components/Text'
import ContactForm from '../../forms/Contact'

interface Props {

}

const ContactScreen: React.FC<Props> = () => {
  return (
    <div>
      <Text
        tag="h1"
      >
        Fale conosco
      </Text>

      <ContactForm />
    </div>
  )
}

export default ContactScreen
